import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { useCustomName } from "hooks"
import { getFormIsSubform, getFormQuestionType } from "reduxSlices/formBuilderSlice"
import { DEPARTMENT_KEY, FACILITY_KEY } from "utils/customNameHelpers"
import { formElementTypeOptions, LOCATION_TYPE, questionTypeIcon } from "views/Forms/FormElementTypes"
import SvgSpriteIcon from "shared/SvgSpriteIcon"

const QuestionTypeOverview = ({ sectionIndex, questionIndex }) => {
  const isSubform = useSelector(getFormIsSubform)
  const questionType = useSelector(getFormQuestionType({ sectionIndex, questionIndex }))

  const { name: facilityName } = useCustomName(FACILITY_KEY)
  const { name: departmentName } = useCustomName(DEPARTMENT_KEY)

  const elementType = formElementTypeOptions(isSubform).find(({ value }) => value === questionType)
  const iconName = questionTypeIcon({ questionType })

  const { description } = elementType

  const descriptionText = questionType === LOCATION_TYPE
    ? description({ facilityName, departmentName })
    : description

  return (
    <div className="p-6 border-b border-lightgray-3">
      <div className="pb-2">
        <SvgSpriteIcon
          iconName={iconName}
          className="p-1.5 rounded bg-white h-8 w-8"
        />
      </div>
      <div className="font-semibold">
        { elementType.label }
      </div>
      <div className="pt-2 leading-relaxed">
        { descriptionText }
      </div>
    </div>
  )
}

QuestionTypeOverview.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default QuestionTypeOverview
